<template>
  <div>
    <!-- QA汇总 -->
    <el-dialog :title="$t('message.qaSummary')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1400px" center>
      <div class="content">
        <div class="search">
          <!-- 关键词 -->
          <div class="item">
            <el-input :placeholder="$t('message.keyword')" v-model="datas.keyword"></el-input>
          </div>
          <!-- 分类 -->
          <div class="item">
            <el-select :placeholder="$t('message.classification')" v-model="datas.category_id" style="width: 100%;"
              filterable>
              <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="articleList">{{ $t('message.inquire') }}</el-button>
        </div>
        <!-- 列表 -->
        <div class="table">
          <div class="item" v-for="(item, index) in tableData" :key="index">
            <div class="head">
              <!-- 排序 -->
              <div class="sort items">
                {{ $t('message.sort') }}
              </div>
              <!-- 类目名 -->
              <div class="categoryName  items">
                {{ $t('message.categoryName') }}
              </div>
            </div>
            <div class="content">
              <!-- 排序 -->
              <div class="sort items">
                {{ item.sort }}
              </div>
              <!-- 类目名 -->
              <div class="categoryName  items">
                {{ item.name }}
              </div>
            </div>
            <ol v-if="item.qa_article != false">
              <!-- 题目 -->
              <li class="flex3"> {{ $t('message.subject') }}</li>
              <!-- 答案 -->
              <li class="flex5"> {{ $t('message.answer') }}</li>
              <!-- 排序 -->
              <li> {{ $t('message.sort') }}</li>
            </ol>
            <ul v-for="(items, indexs) in item.qa_article" :key="indexs">
              <!-- 题目 -->
              <li class="flex3"> {{ items.title }}</li>
              <!-- 答案 -->
              <li class="flex5" v-html="items.content"></li>
              <!-- 排序 -->
              <li class="flex"> {{ items.sort }}</li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      datas: {
        keyword: '',
        category_id: '',
      },
      tableData: [],
      categoryList: [],
      dialogVisible: false,
    };
  },
  created() {
    this.$api.siteConfiguration.categoryList().then(res => {
      this.categoryList = res.data
    })

    this.articleList()
  },
  methods: {
    articleList() {
      this.$api.siteConfiguration.articleList(this.datas).then(res => {
        this.tableData = res.data
      })
    },

  },
};
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 24px;
  }
}



.table {
  max-height: 700px;
  overflow-y: auto;
  margin-top: 20px;

  .item {
    &:nth-child(1) {
      border-top: 1px solid #ccc;
    }

    i {
      margin-left: 20px;
      font-size: 25px;
      cursor: pointer;

      &:hover {
        color: #b4272d;
      }

    }

    .head,
    .content {
      display: flex;
      background-color: #EDEFF4;
      border: 1px solid #ccc;
      border-top: 0;



      .items {
        text-align: center;
        padding: 10px 0;
        border-right: 1px solid #ccc;

        &:nth-last-child(1) {
          border: 0;
        }
      }

      .sort {
        flex: 1;
      }

      .categoryName {
        flex: 8;
      }

      .operation {
        flex: 1.5;
      }
    }

    .content {
      background-color: #fff;
      border-top: 0 !important;
    }

    ol {
      border: 1px solid #ccc;
      border-top: 0;
      text-align: center;
    }

    ul {
      border: 1px solid #ccc;
      border-top: 0;
      padding: 0;
    }

    li {
      border-right: 1px solid #ccc;
      padding: 10px 0;
      display: block;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex3 {
      flex: 3;
    }

    .flex5 {
      flex: 5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

}

/deep/.el-dialog {
  margin-top: 30px !important;
}
</style>